import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "container"
};

const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "导出数据类型配置"), /*#__PURE__*/_createElementVNode("div", {
  class: "sub-title"
}, "配置导出数据类型")], -1);

const _hoisted_3 = {
  class: "check-list"
};
const _hoisted_4 = {
  class: "check-item"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("span", null, "可导出原始数据"), /*#__PURE__*/_createElementVNode("span", {
  class: "sub"
}, "（导出用户权限范围内分销商抽取的所有流向数据）")]), /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "请确保关联分销商仅与此团队或相同负责人进行业务合作，否则可能导致其他团队数据泄漏。")], -1);

const _hoisted_6 = {
  class: "check-item"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("span", null, "可导出基础清洗数据"), /*#__PURE__*/_createElementVNode("span", {
  class: "sub"
}, "（导出用户权限范围内分销商抽取的指定品种流向数据）")]), /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "请确保该分销商商品ERP编码已在平台全部维护且于厂家商品关联正确，否则数据将会缺失或错误。")], -1);

const _hoisted_8 = {
  class: "check-item"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("span", null, "可导出深度清洗数据"), /*#__PURE__*/_createElementVNode("span", {
  class: "sub"
}, "（导出用户权限范围内分销商抽取的指定品种在用户负责业务区域的流向数据）")]), /*#__PURE__*/_createElementVNode("div", {
  class: "tips"
}, "请定期查看普查客户申请表流向来源客户申请，否则会导致数据缺漏。")], -1);

const _hoisted_10 = /*#__PURE__*/_createTextVNode("取消");

const _hoisted_11 = /*#__PURE__*/_createTextVNode("确认");

import { get } from 'lodash-es';
import { reactive, computed, watch } from 'vue';
import { getBillAuth, saveBillAuth } from '@/request';
import { ElMessage } from 'element-plus';
export default {
  name: 'flowPermissionModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supUserId: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const permission = reactive({
      originalBillExport: 0,
      basicBillExport: 0,
      depthBillExport: 0
    });
    watch(() => props.modelValue, v => {
      if (v) reset();
    });

    function reset() {
      getBillAuth({
        supUserId: props.supUserId,
        __warn: true
      }).then(res => {
        const {
          success,
          data
        } = res;
        if (!success) return;
        permission.originalBillExport = get(data, 'originalBillExport', 0);
        permission.basicBillExport = get(data, 'basicBillExport', 0);
        permission.depthBillExport = get(data, 'depthBillExport', 0);
      });
    }

    function submit() {
      let body = _objectSpread({
        supUserId: props.supUserId
      }, permission);

      saveBillAuth(body).then(res => {
        let {
          success,
          msg
        } = res;

        if (!success) {
          ElMessage.error(msg);
          return;
        }

        ElMessage.success('操作成功');
        visible.value = false;
      });
    }

    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _isRef(visible) ? visible.value = $event : null),
        title: "流向权限",
        "custom-class": "flow-permission-modal",
        top: "20px",
        width: "70%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: _cache[3] || (_cache[3] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_checkbox, {
          modelValue: permission.originalBillExport,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => permission.originalBillExport = $event),
          "true-label": 1,
          "false-label": 0
        }, null, 8, ["modelValue"]), _hoisted_5]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_checkbox, {
          modelValue: permission.basicBillExport,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => permission.basicBillExport = $event),
          "true-label": 1,
          "false-label": 0
        }, null, 8, ["modelValue"]), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_el_checkbox, {
          modelValue: permission.depthBillExport,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => permission.depthBillExport = $event),
          "true-label": 1,
          "false-label": 0
        }, null, 8, ["modelValue"]), _hoisted_9])])])]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};